import * as yup from "yup";
import { CreateVariantsFromTemplateFormValues } from "./types";

export const defaultFormValues: CreateVariantsFromTemplateFormValues = {
  id: "",
  optionGroupTemplateId: "",
  selectedOptions: [],
};

export const schema = yup.object().shape({
  id: yup.string().required("Product is required"),
  optionGroupTemplateId: yup.string().required("Variant is required"),
  selectedOptions: yup.array().of(
    yup.object().shape({
      name: yup.string().required("Option is required"),
      value: yup.string().required("Value is required"),
    })
  ),
});
